import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, Tag, Row, Col, Card, Typography, Button, Descriptions, Modal, Spin, Collapse, Space, Image, Empty } from 'antd'

import { getScheduleByCustomer, getSpecificCustomerSchedule, removeCustomerSchedule } from '../../redux/actions/CustomerScheduleActions';
import { ClockCircleOutlined, DeleteOutlined, EditOutlined, PlusOutlined, ProfileOutlined, ReloadOutlined } from '@ant-design/icons';
import { checkPermission } from '../../utils/permission';
import { ConvertCustomerScheduleStatus, ConvertCustomerScheduleType, isValidDate } from '../../utils/helpers';
import HtmlParser from 'react-html-parser';
import moment from 'moment';
import CustomerScheduleForm from './CustomerScheduleForm';
import ExpandableText from '../../components/ExpandableText';
import CustomerMediaProfileScheduleForm from '../media/CustomerMediaProfileScheduleForm';
import { getSpecificCustomer } from '../../redux/actions/customerActions';

const { Text } = Typography;
const { confirm } = Modal;
const { Panel } = Collapse;

class ScheduleCustomerDetail extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            currentItem: [],
            isOpenForm: false,
            currentCustomer: null,
            currentData: null,
            schedule_id: null,
            openMediaIds: new Set(),
            isOpenProfileForm: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    openForm() {
        this.setState({ currentCustomer: this.props.currentCustomer, isOpenForm: true })
    }


    onCancel() {
        this.setState({
            isOpenForm: false,
            currentData: null,
            //currentItem: [],
            schedule_id: null,
        })
    }

    onCancel2() {
        this.setState({
            isOpenForm: false,
            currentData: null,
            schedule_id: null,
            isOpenProfileForm: false
        })
    }

    loadData() {
        this.setState({ isLoading: true })
        this.props.getScheduleByCustomer(this.props.currentCustomer?.id).then(res => {
            this.setState({ currentItem: res, isLoading: false })
        }).catch(err => {
            this.setState({ isLoading: false })
        });
    }

    openRemove(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeCustomerSchedule(id).then(() => {
                setTimeout(() => {
                    this.loadData();
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    onEdit(id) {
        this.props.getSpecificCustomerSchedule(id).then(res => {
            this.setState({
                currentCustomer: this.props.currentCustomer,
                currentData: res,
                isOpenForm: true
            })
        })
    }

    openUpdateProfile(customer_id, schedule_id) {
        //console.log('customer_id', customer_id);
        //console.log('schedule_id', schedule_id);

        this.props.getSpecificCustomer(customer_id).then(res => {
            this.setState({ isOpenProfileForm: true, currentData: res, schedule_id: schedule_id });
        });
    }

    toggleMedia = (id) => {
        this.setState(prev => {
            const s = new Set(prev.openMediaIds);
            s.has(id) ? s.delete(id) : s.add(id);
            return { openMediaIds: s };
        });
    };

    render() {
        var { currentItem, currentData, isOpenForm, currentCustomer, isLoading, isOpenProfileForm, schedule_id } = this.state;

        const renderDocumentCard = (title, images) => (
            <Col xs={24} md={12} className="mb-2">
                <Card size="small" className="border-dashed">
                    <Col xs={24} md={24}>
                        <Text strong style={{ display: "block" }} className="mb-1">
                            {title}
                        </Text>
                        {Array.isArray(images) && images?.length > 0 ? (
                            <Image.PreviewGroup>
                                <Space wrap>
                                    {images.map((item, index) => (
                                        <Image
                                            key={index}
                                            height={50}
                                            width={50}
                                            src={item?.src}
                                            style={{
                                                border: '1px solid #dedede',
                                                objectFit: 'cover',
                                                objectPosition: 'center',
                                            }}
                                        />
                                    ))}
                                </Space>
                            </Image.PreviewGroup>
                        ) : null}
                    </Col>
                </Card>
            </Col>
        );

        return (
            <>
                {/* <Divider orientation="left" orientationMargin="0" className='mt-4 mb-0'>
                    <Tag color='#0b2b33'>3</Tag> Lịch hẹn
                </Divider> */}
                <Row justify="end" className='mb-1'>
                    <Button
                        disabled={!checkPermission('customer_schedule', 'create')}
                        type='dashed' size='small'
                        onClick={() => this.openForm()}
                        className='color-blue'
                        icon={<PlusOutlined />}>
                        Thêm mới
                    </Button>
                </Row>
                {
                    currentItem && currentItem?.length ? (
                        <Spin tip="Loading..." spinning={isLoading}>
                            <Row gutter={16} className='mb-3 row-customer-appointment-schedule'>
                                {
                                    currentItem?.map((item, index) => {

                                        const isOpen = this.state.openMediaIds.has(item.id);

                                        const {
                                            consultation_form = {},
                                            medical_record_book = {},
                                            orther_document = {},
                                            portrait_photo = {},
                                            receipt = {},
                                            x_ray_image = {},
                                            contract_file = {},
                                        } = item?.media?.data || {};

                                        var diffDate = item.time ? moment(item.time, "YYYY-MM-DD").diff(moment().startOf('day'), 'days') : 0;

                                        return (
                                            <Col key={index} xs={24} md={12} lg={8} className='mb-3'>
                                                <Card size="small"
                                                    title={<>{<ClockCircleOutlined />} {ConvertCustomerScheduleType(item.name)}</>}
                                                    extra={
                                                        <>
                                                            {checkPermission('customer_schedule', 'update') ? (
                                                                <a onClick={() => this.onEdit(item.id)} type="link" key="list-vertical-edit">
                                                                    <EditOutlined /> Sửa
                                                                </a>
                                                            ) : null}
                                                            <Divider type='vertical' />
                                                            {checkPermission('customer_schedule', 'remove') ? (
                                                                <span className='delete-icon' onClick={() => this.openRemove([item.id])} type="link" key="list-vertical-delete">
                                                                    <DeleteOutlined /> Xóa
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    }
                                                >
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Thời gian">
                                                                {isValidDate(item.time)} -&nbsp;
                                                                {
                                                                    diffDate ? (
                                                                        <span>
                                                                            {
                                                                                diffDate > 0 ? <Tag color="#f50">Còn lại {diffDate} ngày</Tag> : <Tag color="red">Cách đây {-1 * diffDate} ngày</Tag>
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                item.time != null ? (
                                                                                    <Tag color="#096dd9">Hôm nay</Tag>
                                                                                ) : null
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Ngày tạo">
                                                                {isValidDate(item.created_at)}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Người tạo">
                                                                {item.created_user}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Bác sĩ thực hiện">
                                                                {item.doctors}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Cơ sở thực hiện">
                                                                {item.branch_names}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label="Trạng thái">
                                                                {ConvertCustomerScheduleStatus(item.status)}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Descriptions size="small">
                                                            <Descriptions.Item label={`Thời điểm ${item.name == 'GOILAI' ? 'gọi' : 'đến'}`}>
                                                                {isValidDate(item?.time_to)}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                        <Divider className='no-margin' />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Text strong>Ghi chú: </Text>
                                                        <ExpandableText
                                                            text={item.note}
                                                            rows={1}
                                                        />
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        <Collapse
                                                            bordered={false}
                                                            activeKey={isOpen ? ['media'] : []}
                                                            onChange={() => this.toggleMedia(item.id)}
                                                            style={{ background: 'transparent', marginBottom: 8 }}
                                                            size="small"
                                                        >
                                                            <Panel
                                                                key="media"
                                                                header={
                                                                    <Space size={8}>
                                                                        <Text strong>Ảnh hồ sơ, hợp đồng</Text>
                                                                        {/* <Tag>{isOpen ? 'Đang mở, click để ẩn' : 'Đang ẩn, click để mở'}</Tag> */}
                                                                        <Button
                                                                            size="small"
                                                                            onClick={(e) => { e.stopPropagation(); this.loadData(); }} // chặn toggle khi refresh
                                                                            icon={<ReloadOutlined />}
                                                                            loading={isLoading}
                                                                        >Refresh</Button>
                                                                    </Space>
                                                                }
                                                            >
                                                                {item.media?.data && Object.keys(item.media.data).length > 0 ? (
                                                                    <Row gutter={8}>
                                                                        {Array.isArray(consultation_form?.images) && consultation_form.images.length > 0 &&
                                                                            renderDocumentCard(consultation_form?.name, consultation_form?.images)}
                                                                        {Array.isArray(medical_record_book?.images) && medical_record_book.images.length > 0 &&
                                                                            renderDocumentCard(medical_record_book?.name, medical_record_book?.images)}
                                                                        {Array.isArray(portrait_photo?.images) && portrait_photo.images.length > 0 &&
                                                                            renderDocumentCard(portrait_photo?.name, portrait_photo?.images)}
                                                                        {Array.isArray(x_ray_image?.images) && x_ray_image.images.length > 0 &&
                                                                            renderDocumentCard(x_ray_image?.name, x_ray_image?.images)}
                                                                        {Array.isArray(contract_file?.images) && contract_file.images.length > 0 &&
                                                                            renderDocumentCard(contract_file?.name, contract_file?.images)}
                                                                        {Array.isArray(orther_document?.images) && orther_document.images.length > 0 &&
                                                                            renderDocumentCard(orther_document?.name, orther_document?.images)}
                                                                    </Row>
                                                                ) : (
                                                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                                                )}
                                                            </Panel>
                                                        </Collapse>
                                                    </Col>
                                                    <Col xs={24} md={24}>
                                                        {checkPermission("customer", "update_image_profile") && (
                                                            <>
                                                                <Divider type="vertical" />
                                                                <Button
                                                                    type="primary"
                                                                    size="small"
                                                                    onClick={() => this.openUpdateProfile(item.customer_id, item.id)}
                                                                    icon={<ProfileOutlined />}>Cập nhật ảnh hồ sơ, hợp đồng</Button>
                                                            </>
                                                        )}
                                                    </Col>
                                                </Card>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </Spin>
                    ) : <Row gutter={16}><div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div></Row>
                }

                <CustomerScheduleForm
                    visible={isOpenForm}
                    currentCustomer={currentCustomer}
                    currentItem={currentData}
                    reloadData={() => this.loadData()}
                    onCancel={() => this.onCancel()}
                />
                <CustomerMediaProfileScheduleForm
                    visible={isOpenProfileForm}
                    currentCustomer={currentData}
                    schedule_id={schedule_id}
                    reloadData={() => false}
                    //onCancel={() => this.setState({ isOpenProfileForm: false })}
                    onCancel={() => this.onCancel2()}
                />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getScheduleByCustomer: (customer_id) => dispatch(getScheduleByCustomer(customer_id)),
        getSpecificCustomerSchedule: (id) => dispatch(getSpecificCustomerSchedule(id)),
        removeCustomerSchedule: (id) => dispatch(removeCustomerSchedule(id)),
        getSpecificCustomer: (customer_id) => dispatch(getSpecificCustomer(customer_id)),
    }
}

// export default connect(mapStateToProps, mapDispatchToProps)(ScheduleCustomerDetail);

// Sử dụng forwardRef để truyền ref xuống component
// Mục đích để cho parent component có thể gọi method của child component
const ConnectedScheduleCustomerDetail = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ScheduleCustomerDetail);

export default React.forwardRef((props, ref) => (
    <ConnectedScheduleCustomerDetail {...props} ref={ref} />
));
